// extracted by mini-css-extract-plugin
export default {"header":"_1hr-ZS7R","quickLinks":"i9S2wniC","quickLink":"lskmYLHJ"};